﻿import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import NavTabs from './NavTabs';
import PaginationTabs from './PaginationTabs';

import './NavTabs.scss';

class YearTabs extends Component {
  state = {
    year: this.props.year,
    page: this.props.page || 1,
  };

  // support controlled component
  static getDerivedStateFromProps(props, state) {
    if (props.year !== state.prevYear || props.page !== state.prevPage) {
      return {
        year: props.year,
        page: props.page,
      };
    }
    return null;
  }

  previousPage = () => {
    const { page } = this.state;
    const nextPage = page > 1 ? page - 1 : page;
    if (nextPage !== page && page > 1) {
      this.setState({
        page: nextPage,
      });
      this.props.onChangePage(nextPage);
    }
  };

  nextPage = () => {
    const { page } = this.state;
    const { pages } = this.props;
    const nextPage = page === pages ? page : page + 1;
    if (nextPage !== page && nextPage <= pages) {
      this.setState({
        page: nextPage,
      });
      if (this.props.onChangePage) this.props.onChangePage(nextPage);
    }
  };

  selectYear = year => {
    if (this.state.year !== year) {
      this.setState({
        year,
        page: 1,
      });
      if (this.props.onChangeYear) this.props.onChangeYear(year);
    }
  };

  createTabs = () => {
    if (!this.props.years.length) {
      return [
        {
          label: new Date().getFullYear(),
          active: true,
          onClick: undefined,
        },
      ];
    } else if (this.props.years.length > 1) {
      return this.props.years.map(year => ({
        label: year,
        active: year === null || year === this.state.year,
        onClick: () => this.selectYear(year),
      }));
    } else if (this.props.years.length === 1) {
      return this.props.years.map(year => ({
        label: year,
        active: year,
        onClick: () => this.selectYear(year),
      }));
    }
  };

  render() {
    const tabs = this.createTabs();
    const children = this.props.children ? this.props.children(this.state) : null;
    return (
      <Fragment>
        <div style={{ position: 'relative' }}>
          <NavTabs tabs={tabs} />
          <PaginationTabs
            total={this.props.pages}
            page={this.state.page}
            onPrevious={this.previousPage}
            onNext={this.nextPage}
            hidePages={this.props.hidePages}
          />
        </div>
        {children}
      </Fragment>
    );
  }
}

YearTabs.propTypes = {
  year: PropTypes.number,
  years: PropTypes.arrayOf(PropTypes.number),
  children: PropTypes.func,
  pages: PropTypes.number,
  onChangeYear: PropTypes.func,
  onChangePage: PropTypes.func,
  page: PropTypes.number,
};

YearTabs.defaultProps = {
  year: new Date().getFullYear(),
  years: [],
  children: undefined,
  pages: undefined,
  page: 1,
  onChangePage: () => {},
  onChangeYear: () => {},
};

export default YearTabs;
